import React from "react";
import { TopNav, BottomNav, GuestStickyBar } from "./Navigation";
import Footer from "./Footer";

export default function AppShell({ children, bg = "bg-radial-neon" }) {
  return (
    <div className={`min-h-screen ${bg} flex flex-col`} data-testid="app-shell">
      <TopNav />
      <GuestStickyBar />
      <main className="flex-1 pb-28 md:pb-10">{children}</main>
      <Footer />
      <BottomNav />
    </div>
  );
}

export function PageContainer({ children, className = "" }) {
  return (
    <div
      className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-10 ${className}`}
    >
      {children}
    </div>
  );
}

export function PageHeader({ title, subtitle, kicker, action }) {
  return (
    <div className="flex flex-col gap-2 mb-6 sm:mb-8" data-testid="page-header">
      {kicker && (
        <span className="inline-flex items-center gap-2 self-start px-3 py-1 rounded-full bg-neon/10 border border-neon/30 text-neon text-xs font-semibold uppercase tracking-wider">
          {kicker}
        </span>
      )}
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-display font-black tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-zinc-400 mt-2 max-w-2xl">{subtitle}</p>
          )}
        </div>
        {action}
      </div>
    </div>
  );
}
